module.exports = __webpack_public_path__ + "static/media/Adviesbox_PRD.062ff735.png";